<!--sidebar-->
<c-sidebar #sidebar="cSidebar" class="d-print-none sidebar sidebar-fixed" id="sidebar" visible>
  <c-sidebar-brand [brandFull]="{
      src: 'assets/img/brand/LOGO.png',
      width: 180,
      height: 60,
      alt: 'Cartelys',
    }" [brandNarrow]="{
      src: 'assets/img/brand/LOGO.png',
      width: 40,
      height: 40,
      alt: 'Cartelys',
    }" routerLink="./" />

  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" />
  </ng-scrollbar>
  @if (!sidebar.narrow) {
  <c-sidebar-toggler toggle="unfoldable" cSidebarToggle="sidebar" />
  }
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-default-header class="mb-4 d-print-none header-sticky" position="sticky" sidebarId="sidebar" />
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <c-container breakpoint="lg" class="h-auto">
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>